// extracted by mini-css-extract-plugin
export default {"defaultButton":"DAFileUpload_defaultButton__9RSFj","containedButton":"DAFileUpload_containedButton__IDYhN","startIcon":"DAFileUpload_startIcon__-6h3k"};